export const PHONE_NUMBER = '(888)212-3437';
export const ADDRESS = '1200 Placid Avenue Suite 400, Plano Texas 75074';
export const EMAIL = 'support@mypoolhut.com';
